module.exports = __webpack_public_path__ + "img/naira-icon.782a6161.svg";